module.exports = __webpack_public_path__ + "dist/img/QRCode-Pay.a34ec7c6.jpg";